module.exports = __webpack_public_path__ + "img/Window-Mount.d48ec3b4.png";